import { render } from "./testimoneals.vue?vue&type=template&id=015c2c66&scoped=true"
const script = {}

import "./testimoneals.vue?vue&type=style&index=0&id=015c2c66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015c2c66"]])

export default __exports__